import { Resources } from 'constants/resources';

import { useFormContext, useWatch } from 'react-hook-form';
import { AutocompleteInputSynced } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { cleanEmpty } from 'utils/cleanEmpty';

import { OrderManualCreateSection } from './OrderManualCreateSection';

export const PROVIDER_DEPENDENTS = ['gateway', 'gatewayName', 'method', 'methodName'];
export const GATEWAY_DEPENDENTS = ['method', 'methodName'];

export const OrderManualCreateProvidersFields = () => {
  const { resetField } = useFormContext();
  const merchant = useWatch({ name: 'merchant' });
  const provider = useWatch({ name: 'provider' });
  const gateway = useWatch({ name: 'gateway' });

  return (
    <OrderManualCreateSection title="Данные провайдера">
      <ReferenceInput
        filter={cleanEmpty({ merchantAccounts: { merchants: merchant } })}
        perPage={100}
        reference={Resources.Providers}
        sort={{ field: 'name', order: 'ASC' }}
        source="provider"
      >
        <AutocompleteInputSynced
          clearOnBlur={false}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          isRequired
          label="Провайдер"
          onChange={() => PROVIDER_DEPENDENTS.forEach((field) => resetField(field))}
          optionText="name"
          syncFields={{ providerName: 'name' }}
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput
        filter={cleanEmpty({ merchantAccounts: { merchants: merchant }, provider })}
        perPage={100}
        reference={Resources.Gateways}
        source="gateway"
      >
        <AutocompleteInputSynced
          disabled={!provider}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          isRequired
          label="Шлюз"
          onChange={() => GATEWAY_DEPENDENTS.forEach((field) => resetField(field))}
          optionText="name"
          syncFields={{ gatewayName: 'name' }}
          variant="outlined"
        />
      </ReferenceInput>
      <ReferenceInput
        filter={cleanEmpty({ gateway })}
        perPage={100}
        reference={Resources.Methods}
        source="method"
      >
        <AutocompleteInputSynced
          disabled={!gateway}
          filterToQuery={(searchText: string) => ({ name: searchText })}
          helperText={false}
          isRequired
          label="Метод"
          optionText="name"
          syncFields={{ methodName: 'name' }}
          variant="outlined"
        />
      </ReferenceInput>
    </OrderManualCreateSection>
  );
};
